import api from './api';

function esIdValido(valor) {
  const numero = Number(valor);
  return Number.isInteger(numero) && numero > 0;
}

function validarId(valor, nombre = 'Id') {
  if (!esIdValido(valor)) {
    throw new Error(`${nombre} no es válido.`);
  }

  return Number(valor);
}

export function listarCajas(params = {}) {
  return api.get('/cajas', { params }).then(res => res.data || []);
}

export function obtenerCaja(id) {
  return api.get(`/cajas/${validarId(id)}`).then(res => res.data);
}

export function obtenerSaldoCaja(id) {
  if (!esIdValido(id)) return Promise.resolve({ ok: false, saldoActual: null });
  return api.get(`/cajas/${validarId(id)}/saldo`).then(res => res.data);
}

export function crearCaja(payload) {
  return api.post('/cajas', payload).then(res => res.data);
}

export function editarCaja(id, payload) {
  return api.put(`/cajas/${validarId(id)}`, payload).then(res => res.data);
}

export function activarCaja(id) {
  return api.post(`/cajas/${validarId(id)}/activar`).then(res => res.data);
}

export function desactivarCaja(id) {
  return api.post(`/cajas/${validarId(id)}/desactivar`).then(res => res.data);
}

export function registrarIngreso(id, payload) {
  return api.post(`/cajas/${validarId(id)}/ingresos`, payload).then(res => res.data);
}

export function registrarSalida(id, payload) {
  return api.post(`/cajas/${validarId(id)}/salidas`, payload).then(res => res.data);
}

export function registrarAjuste(id, payload) {
  return api.post(`/cajas/${validarId(id)}/ajustes`, payload).then(res => res.data);
}


export function registrarTraspaso(payload) {
  return api.post('/cajas/traspasos', payload).then(res => res.data);
}

export function listarTraspasos(params = {}) {
  return api.get('/cajas/traspasos', { params }).then(res => res.data);
}

export function obtenerTraspaso(id) {
  return api.get(`/cajas/traspasos/${validarId(id, 'Traspaso')}`).then(res => res.data);
}

export function cancelarTraspaso(id, payload) {
  return api.post(`/cajas/traspasos/${validarId(id, 'Traspaso')}/cancelar`, payload).then(res => res.data);
}
export function obtenerMovimientosCaja(id, params = {}) {
  if (!esIdValido(id)) {
    return Promise.resolve({
      ok: true,
      movimientos: [],
      paginacion: { paginaActual: 1, pageSize: params.pageSize || 25, totalRegistros: 0, totalPaginas: 0 }
    });
  }

  return api.get(`/cajas/${validarId(id)}/movimientos`, { params }).then(res => res.data);
}

export function obtenerBalanzaCaja(id, params = {}) {
  if (!esIdValido(id)) {
    return Promise.resolve({ ok: true, movimientos: [] });
  }

  return api.get(`/cajas/${validarId(id)}/balanza`, { params }).then(res => res.data);
}



